export enum SocketEventNamespace {
  DEVICES = 'devices',
  INCIDENTS = 'incidents',
  WORKFLOW = 'workflow',
}

export enum SocketEventType {
  DEVICE_UPDATED = 'device:updated',
  INCIDENT_CREATED = 'incidents:created',
  INCIDENT_IN_PROGRESS = 'incidents:progress',
  INCIDENT_RESOLVED = 'incidents:resolved',
  WORKFLOW_TRIGGERED = 'workflow:triggered',
  WORKFLOW_ATTEMPTS_UPDATED = 'workflow:attempts_updated',
  WORKFLOW_STATUS_CHANGED = 'workflow:status_changed',
}
